import React, { useEffect } from "react"
// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import "../styles.scss"

export default function Footer(props) {
  const handleFooterCode = props => {
    let path = typeof window !== "undefined" ? window.location.pathname : ""

    switch (props.site) {
      case "gateway":
        return <span>06/2025&nbsp;&nbsp;&nbsp;USAVA23.0007.4</span>
      case "ism":
        return <span>06/2025&nbsp;&nbsp;&nbsp;USAVA23.0007.4</span>
      case "advsm":
        if (path === "/advsm/resources/" || path === "/advsm/success/") {
          return <span>06/2025&nbsp;USAVA23.0007.4</span>
        }
        return <span>06/2025&nbsp;USAVA23.0007.4</span>
      case "gist":
        return <span>06/2025&nbsp;&nbsp;&nbsp;USAVA23.0007.4</span>
      default:
        return <span>06/2025&nbsp;&nbsp;&nbsp;USAVA23.0007.4</span>
    }
  }
  const handleCopyright = props => {
    let path = typeof window !== "undefined" ? window.location.pathname : ""

    switch (props.site) {
      case "gateway":
        return "2025"
      case "ism":
        return "2025"
      case "advsm":
        if (path === "/advsm/resources/" || path === "/advsm/success/") {
          return "2025"
        }
        return "2025"
      case "gist":
        return "2025"
      default:
        return "2025"
    }
  }

  useEffect(() => {
    //OneTrust bug fix:
    //Footer link "Do Not Sell Or Share My Personal Information" does NOT trigger
    //Onetrust banner after browsing differnt sections of the sites
    const oneTrustTrigger = document.querySelector(".ot-sdk-show-settings")
    oneTrustTrigger.addEventListener("click", function (e) {
      e.preventDefault()
      let oneTrustFilter = document.querySelector(".onetrust-pc-dark-filter")
      let oneTrustModal = document.querySelector("#onetrust-pc-sdk")
      //console.log(oneTrustFilter);
      //console.log(oneTrustModal);
      if (oneTrustFilter && oneTrustModal) {
        oneTrustFilter.removeAttribute("style")
        oneTrustModal.removeAttribute("style")
      }
    })
  }, [])

  return (
    <footer className={`Footer footer-${props.site}`}>
      <a href="https://www.blueprintmedicines.com/" target="_blank">
        <StaticImage
          src="../../images/blueprint-medicines-logo.png"
          className="FooterLogo"
          alt="Blueprint™ logo"
          placeholder="none"
          quality={100}
        />
      </a>
      <div className="FooterLinkContainer">
        <a
          href="https://www.blueprintmedicines.com/terms-of-use/"
          target="_blank"
        >
          Terms of Use
        </a>
        <a
          href="https://www.blueprintmedicines.com/privacy-notice/"
          target="_blank"
        >
          Privacy Notice
        </a>
        <a href="#" className="ot-sdk-show-settings">
          Do Not Sell or Share My Personal Information
        </a>
        <a
          href="https://privacyportal.onetrust.com/webform/80df49f1-6c7b-4f74-90d4-db304d14dd3a/f7482e77-b78a-48d5-b13a-764939c7f304"
          target="_blank"
        >
          Limit the Use of My Sensitive Information
        </a>
      </div>
      <p>
        AYVAKIT, Blueprint Medicines, YourBlueprint and associated logos are
        trademarks of Blueprint Medicines Corporation.
      </p>
      <p>All other trademarks are the property of their respective owners.</p>
      <p>
        &copy; {handleCopyright(props)} Blueprint Medicines Corporation. This
        site is intended for US audiences only.
      </p>
      {handleFooterCode(props)}
      <StaticImage
        src="../../images/footer-accent.png"
        className="FooterAccent"
        alt="FooterAccent"
        placeholder="none"
        quality={100}
      />
    </footer>
  )
}
